import { useCheckout } from '@/context/checkout';
import Location from '../icons/Location';
import { useRouter } from 'next/router';

const BranchInfo = ({
  t,
  info,
  map,
  branchInView = null,
  setBranchInView = null,
  setFieldValue = null,
}) => {
  const checkoutContext = useCheckout();
  const { pathname } = useRouter();
  const { asPath } = useRouter();
  const inBranchesPage = asPath?.includes('branches');

  const active = checkoutContext?.checkout?.pickupStore?.id == info?.id;

  return (
    <div
      className={`flex flex-col border
      ${
        inBranchesPage
          ? `hover:border-black/50 ${branchInView?.id == info?.id ? 'border-black/50' : ''}`
          : ''
      } 
      gap-3 rounded-md border p-3 max-lg:mt-3 max-lg:min-w-60`}
    >
      <p className='text-lg font-semibold text-red-600'>{info?.name || ''}</p>
      <div className='-mt-1 flex gap-2'>
        <Location className='mt-1' />
        <p className='line-clamp-2 min-h-12 flex-1 text-zinc-500'>
          {info?.address || ''}
        </p>
      </div>
      <div className='flex justify-end gap-2'>
        <button
          className='w-fit rounded-md bg-primary px-3 py-1 text-white'
          onClick={() => {
            if (!pathname?.startsWith('/checkout')) {
              setBranchInView(info);
              map.panTo({
                lng: parseFloat(info?.lng),
                lat: parseFloat(info?.lat),
              });
            }
          }}
        >
          {t('Show Map')}
        </button>
      </div>
      {!inBranchesPage && (
        <div className='flex justify-between'>
          <button
            onClick={() =>
              map.panTo({
                lng: parseFloat(info?.lng),
                lat: parseFloat(info?.lat),
              })
            }
            className='rounded-md bg-black px-5 py-2 text-white lg:w-fit'
          >
            {t('Show Map')}
          </button>
          <button
            onClick={() => {
              map.panTo({
                lng: parseFloat(info?.lng),
                lat: parseFloat(info?.lat),
              });
              checkoutContext.dispatch({
                type: 'pickup_store',
                payload: { id: info?.id },
              });
              setFieldValue('store_id', info?.id);
            }}
            className={`px-5 py-2 ${
              active ? 'border bg-white text-black' : 'bg-black text-white'
            } rounded-md  lg:w-fit`}
          >
            {t('Set Address')}
          </button>
        </div>
      )}
    </div>
  );
};

export default BranchInfo;
